import OurGuarantee from './OurGuarantee';

export default OurGuarantee;
